.layout {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  min-width: 0;
  padding-top: var(--pgm-sys-spacing-6);
}

.header {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.createButton {
  flex-shrink: 0;
}

.filters {
  display: flex;
}

.filters .statusFilter {
  --md-outlined-field-top-space: 16px;
  --md-outlined-field-bottom-space: 16px;
  --md-outlined-field-with-label-top-space: 16px;
  --md-outlined-field-with-label-bottom-space: 16px;
  flex: 0 0 220px;
}

.noticeTitle {
  color: var(--pgm-sys-color-on-surface);
  overflow-wrap: anywhere;
}

.period {
  display: flex;
  flex-direction: column;
}

.muted {
  color: var(--pgm-sys-color-on-surface-variant);
}

.actions {
  display: inline-flex;
  gap: var(--pgm-sys-spacing-1);
  justify-content: flex-end;
}

.tag {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex-shrink: 0;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  white-space: nowrap;
}

.tagDot {
  border-radius: 50%;
  height: 8px;
  width: 8px;
}

.tagDraft {
  background-color: var(--pgm-sys-color-warning-container);
  color: var(--pgm-sys-color-on-warning-container);
}

.tagDraft .tagDot {
  background-color: var(--pgm-sys-color-warning);
}

.tagScheduled {
  background-color: var(--pgm-sys-color-info-container);
  color: var(--pgm-sys-color-on-info-container);
}

.tagScheduled .tagDot {
  background-color: var(--pgm-sys-color-info);
}

.tagLive {
  background-color: var(--pgm-sys-color-success-container);
  color: var(--pgm-sys-color-on-success-container);
}

.tagLive .tagDot {
  background-color: var(--pgm-sys-color-success);
}

.tagEnded {
  background-color: var(--pgm-sys-color-surface-container-highest);
  color: var(--pgm-sys-color-on-surface-variant);
}

.tagEnded .tagDot {
  background-color: var(--pgm-sys-color-outline);
}

.compactRow {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-2);
  justify-content: space-between;
}

.compactMain {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.compactTitle {
  color: var(--pgm-sys-color-on-surface);
  overflow-wrap: anywhere;
}

.compactTags {
  display: flex;
  margin-top: var(--pgm-sys-spacing-1);
}

.empty,
.error {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
  text-align: center;
}

.error {
  background-color: var(--pgm-sys-color-surface-container-lowest);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 12px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6);
}

.emptyIcon {
  color: var(--pgm-sys-color-on-surface-variant);
  font-size: 48px;
  line-height: 1;
}

.emptyText {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding-top: var(--pgm-sys-spacing-2);
}

.field {
  min-height: 80px;
  min-width: 0;
}

.row > .field {
  flex: 1 1 240px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
}

.group {
  border: 0;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: var(--pgm-sys-spacing-2) 0 0;
  min-width: 0;
  padding: 0;
}

.legend {
  color: var(--pgm-sys-color-on-surface);
  margin-bottom: var(--pgm-sys-spacing-2);
  padding: 0;
}

.formatting {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: calc(-1 * var(--pgm-sys-spacing-2)) 0 var(--pgm-sys-spacing-2);
}

.formattingToggle {
  align-self: flex-start;
  margin-left: calc(-1 * var(--pgm-sys-spacing-3));
}

.formattingPanel {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
  padding: var(--pgm-sys-spacing-4);
}

.formattingList {
  display: grid;
  gap: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-4);
  grid-template-columns: minmax(0, auto) minmax(0, 1fr);
  margin: 0;
}

.formattingList dt {
  color: var(--pgm-sys-color-on-surface);
}

.formattingList dd {
  margin: 0;
}

.formattingList code {
  background-color: var(--pgm-sys-color-surface-container-highest);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-surface);
  font-family: "Roboto Mono", ui-monospace, monospace;
  font-size: 0.875em;
  padding: 1px 6px;
  white-space: pre-wrap;
}

.formattingNote {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.publishedHint {
  align-items: flex-start;
  background-color: var(--pgm-sys-color-info-container);
  border-radius: 12px;
  color: var(--pgm-sys-color-on-info-container);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  margin: 0 0 var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
}

.previewButton {
  margin-right: auto;
}

.formError {
  color: var(--pgm-sys-color-error);
  margin: 0;
}

@media (max-width: 599.98px) {
  .createButton {
    width: 100%;
  }

  .filters .statusFilter {
    flex: 1 1 100%;
  }
}
